import { useSearchParams } from 'react-router-dom';

export function useDeepLinkedArtwork() {
  const [searchParams, setSearchParams] = useSearchParams();
  const deepLinkedSlug = searchParams.get('artwork');

  const setArtworkParam = (slug) => {
    const next = new URLSearchParams(searchParams);
    if (slug) {
      next.set('artwork', slug);
    }
    setSearchParams(next, { replace: false });
  };

  const clearArtworkParam = () => {
    const next = new URLSearchParams(searchParams);
    next.delete('artwork');
    setSearchParams(next, { replace: true });
  };

  return { deepLinkedSlug, setArtworkParam, clearArtworkParam };
}
